import React, { FunctionComponent, useEffect, useState } from "react";
import firebase from "firebase/app";
import Button from "../Button";

import { NotificationManager } from "react-notifications";
import Modal from "../Modal";
import Checkbox from "../Checkbox";
import styled from "styled-components";
import variables from "theme/variables";
import { useAuth } from "reactfire";

const LoginModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${variables.SPACING * 2}px ${variables.SPACING * 8}px;

  > *:first-child {
    margin-bottom: ${variables.SPACING * 2}px;
  }
`;

const Login: FunctionComponent<{}> = () => {
  const auth = useAuth();

  const [isModalOpen, setModalOpen] = useState(false);
  const [keepSigned, setKeepSigned] = useState(false);

  const onLogin = async () => {
    if (keepSigned) {
      await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    } else {
      await auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
    }

    const provider = new firebase.auth.GoogleAuthProvider();

    try {
      await auth.signInWithPopup(provider);
    } catch (e) {
      console.log(e);
      NotificationManager.error(e.toString());
    }
  };

  const onClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <Button onClick={onClick} active>
        Sign In
      </Button>

      {isModalOpen && (
        <Modal onClose={setModalOpen.bind(null, false)}>
          <LoginModal>
            <Checkbox checked={keepSigned} onChecked={setKeepSigned} label="Remember Me" />
            <Button onClick={onLogin}>Sign in</Button>
          </LoginModal>
        </Modal>
      )}
    </>
  );
};

export default Login;
